export enum Role {
  User = 'User',
  Admin = 'Admin',
  Editor = 'Editor',
  Psychologist = 'Psycholog',
  CRM = 'CRM'
}
